<div class="mini-basket-container">
  <div class="content" *ngIf="(basket$ | async) as basket">
    <div class="headline" *ngIf="basket.entries?.length > 0; else emptyBasketHeadline">
      {{ 'basket.headline' | translate }}
    </div>
    <ng-template #emptyBasketHeadline>
      <div class="headline">
        {{ 'basket.noResult.headline' | translate }}
      </div>
    </ng-template>
    <div class="product-list" *ngIf="basket.entries as entries">
      <div class="item" *ngFor="let entry of entries">
        <img
          *ngIf="entry.product?.images; else noImage"
          [lazyLoad]="entry.product?.images[0]?.url + '?width=63&height=63&padColor=fff'"
          [defaultImage]="entry.product?.images[0]?.url + '?width=50&height=50&padColor=fff'"
          [alt]="entry.product?.images[0]?.altText"
          [title]="entry.product?.images[0]?.titleText || entry.product?.images[0]?.altText"
          class="image"
          errorImage="./assets/ui/shared/error/not_found_error_image.png"
          src="#"
        />
        <ng-template #noImage>
          <img
            class="image"
            lazyLoad="./assets/ui/shared/error/not_found_error_image.png"
            defaultImage="./assets/ui/shared/error/not_found_error_image.png"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            alt="missing_product_image"
            title="missing_product_image"
            src="#"
          />
        </ng-template>
        <div class="itemContent">
          <div class="itemTitle"> {{ entry.product?.name }} </div>
          <ul class="itemFeatures">
            <li *ngFor="let category of entry?.product.categories"> {{ category.formattedName }} </li>
            <li *ngFor="let option of entry?.productOptions">
              <span *ngIf="option.code === 'CONTRACT'">{{ 'basket.miniBasket.contract' | translate }}</span>
            </li>
          </ul>
          <div class="itemDetails">
            <div class="itemQuantity">
              <div class="itemDetailLabel">{{ 'basket.miniBasket.count' | translate }}</div>
              <div class="itemDetailValue">{{ entry.quantity }}</div>
            </div>
            <div class="itemPrice">
              <div class="itemDetailLabel">{{ 'basket.miniBasket.unitPrice' | translate}}</div>
              <div class="itemDetailValue">{{ entry.product.price.formattedValue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="price" *ngIf="basket.totalPrice.value > 0; else spacer">
        <div class="label">{{ 'basket.miniBasket.price.label' | translate }}</div>
        <div class="value">{{ (basket$ | async)?.subTotal?.formattedValue }}</div>
      </div>
      <ng-template #spacer><div class="spacer"></div></ng-template>
      <div class="button">
        <kion-button
          [title]="'basket.miniBasket.button.toBasket' | translate"
          [isLink]="true"
          [link]="basketLink"
          mode="primary"
        ></kion-button>
      </div>
    </div>
  </div>
</div>
